import { configureStore } from '@reduxjs/toolkit'
import publicGroupSlice from './reducers/publicGroupSlice'

export default configureStore({
  reducer: {
    publicGroup: publicGroupSlice
  },
})
